export const apiUrlByDefault = 'https://api.prod2.blackmoonlab.com/'
export const socketUrlByDefault = 'https://socket.marie.blackmoonlab.com/'
export const cssUrlByDefault = 'https://css.blackmoonlab.com/'
